import { c as _c } from "react/compiler-runtime";
export const StarIcon = t0 => {
  const $ = _c(5);
  const {
    color: t1,
    testid
  } = t0;
  const color = t1 === undefined ? "#64666A" : t1;
  let t2;
  if ($[0] !== color) {
    t2 = {
      width: "15px",
      height: "15px",
      marginRight: "2px",
      marginLeft: "1px",
      background: color,
      overflow: "hidden",
      WebkitMaskImage: "var(--star-svg)",
      maskImage: "var(--star-svg)"
    };
    $[0] = color;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2 || $[3] !== testid) {
    t3 = <span style={t2} data-testid={testid} />;
    $[2] = t2;
    $[3] = testid;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};